import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { PageHeaderAction, PageHeaderConfig } from './page-header.models';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [ButtonModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
})
export class PageHeaderComponent {
  readonly config = input<PageHeaderConfig | null>(null);

  private readonly router = inject(Router);

  readonly actions = computed(() => this.config()?.actions ?? []);
  readonly title = computed(() => this.config()?.title ?? 'Untitled');
  readonly headerIconClass = computed(() => `pi ${this.config()?.icon ?? 'pi-folder'}`);
  readonly hasBackAction = computed(() => {
    const config = this.config();
    return Boolean(config?.backRoute || config?.backHandler);
  });

  onBackClick(): void {
    const config = this.config();
    if (!config) {
      return;
    }

    if (config.backHandler) {
      void config.backHandler();
      return;
    }

    if (config.backRoute) {
      void this.router.navigateByUrl(config.backRoute);
    }
  }

  isActionOutlined(action: PageHeaderAction): boolean {
    return action.variant === 'outlined';
  }
}
